<form [formGroup]="newQuoteOnExchangeForm" (submit)="submit()">

  <!-- firstName -->
  <mat-form-field appearance="outline">
    <mat-label>First Name</mat-label>
    <input matInput formControlName="firstName" [placeholder]="'First Name'"/>
    @if (newQuoteOnExchangeForm.controls['firstName'].errors?.required) {
      <mat-error>Required</mat-error>
    }
  </mat-form-field>

  <!-- lastName -->
  <mat-form-field appearance="outline">
    <mat-label>Last Name</mat-label>
    <input matInput formControlName="lastName" [placeholder]="'Last Name'"/>
    @if (newQuoteOnExchangeForm.controls['lastName'].errors?.required) {
      <mat-error>Required</mat-error>
    }
  </mat-form-field>

  <!-- dob -->
  <mat-form-field appearnce="outline">
    <mat-label>Date Of Birth</mat-label>
    <input matInput [matDatepicker]="picker1" formControlName="dob" placeholder="MM/DD/YYYY">
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
    @if (newQuoteOnExchangeForm.controls['dob'].errors?.required) {
      <mat-error>Required</mat-error>
    }
  </mat-form-field>

  <!-- email -->
  <mat-form-field appearance="outline">
    <mat-label>Email</mat-label>
    <input matInput formControlName="email" [placeholder]="'Email'"/>
    @if (newQuoteOnExchangeForm.controls['email'].errors?.required) {
      <mat-error>Required</mat-error>
    }
  </mat-form-field>

  <!-- emailConfirmation -->
  <mat-form-field appearance="outline">
    <mat-label>Re-enter Email</mat-label>
    <input matInput formControlName="emailConfirmation" [placeholder]="'Re-enter Email'"/>
    @if (newQuoteOnExchangeForm.controls['emailConfirmation'].errors?.required) {
      <mat-error>Required</mat-error>
    }
    @if (newQuoteOnExchangeForm.controls['emailConfirmation'].errors?.emailAddressesNotSame) {
      <mat-error>Email addresses do not match</mat-error>
    }
  </mat-form-field>

  <!-- address1 -->
  <mat-form-field appearance="outline">
    <mat-label>Home Address</mat-label>
    <input matInput formControlName="address1" [placeholder]="'Home Address'"/>
    @if (newQuoteOnExchangeForm.controls['address1'].errors?.required) {
      <mat-error>Required</mat-error>
    }
  </mat-form-field>

  <!-- address2 -->
  <mat-form-field appearance="outline">
    <mat-label>Home Address 2</mat-label>
    <input matInput formControlName="address2" [placeholder]="'Home Address 2'"/>
    @if (newQuoteOnExchangeForm.controls['address2'].errors?.required) {
      <mat-error>Required</mat-error>
    }
  </mat-form-field>

  <!-- city -->
  <mat-form-field appearance="outline">
    <mat-label>City</mat-label>
    <input matInput formControlName="city" [placeholder]="'City'"/>
    @if (newQuoteOnExchangeForm.controls['city'].errors?.required) {
      <mat-error>Required</mat-error>
    }
  </mat-form-field>

  <div class="zip-form" #zipform>

    <!-- ZIP CODE -->
    <mat-form-field appearance="outline" class="maxWidth350">

      <input matInput formControlName="zipCode" maxlength="5" />

      <mat-label>Zip Code</mat-label>
      <!-- Hint -->
      <mat-hint>State and County is based on Zip Code.
        <br>
          @if (!isSingleCounty) {
            <strong>
            This Zip Code covers multiple counties, please select one!</strong>
          }
        </mat-hint>
        <!-- errors -->
        @if (newQuoteOnExchangeForm.controls.zipCode.errors?.required) {
          <mat-error>Zip Code is required</mat-error>
        }
        @if (newQuoteOnExchangeForm.controls.zipCode.errors?.pattern) {
          <mat-error>Only numerical values are allowed</mat-error>
        }
        @if (newQuoteOnExchangeForm.controls.zipCode.errors?.maxlength && !newQuoteOnExchangeForm.controls.zipCode.errors?.pattern) {
          <mat-error>
            Please enter a valid zipcode (5 digits)
          </mat-error>
        }
        @if (newQuoteOnExchangeForm.controls.zipCode.errors?.minlength && !newQuoteOnExchangeForm.controls.zipCode.errors?.pattern) {
          <mat-error>
          Please enter a minimum of 5 digits</mat-error>
        }
        @if (newQuoteOnExchangeForm.controls.zipCode.errors?.wrongZipForRegion) {
          <mat-error>
            The Zip Code you entered is outside the service areas of the states in which we offer plans.
            Please confirm you entered the ZIP code correctly or call 1-888-630-BLUE, 8 a.m. to 8 p.m, seven days a week.
            TTY
            call 711.
          </mat-error>
        }
      </mat-form-field>

      <br />

      <!-- COUNTY (multiple)-->
      <mat-form-field appearance="outline" class="select-mat-form-field maxWidth350">
        <mat-select formControlName="county" (selectionChange)="onCountyMultipleChange($event)"
          [disabled]="isSingleCounty">
          @for (countyInfo of counties; track countyInfo) {
            <mat-option [value]="countyInfo">
              {{countyInfo.county}}
            </mat-option>
          }
        </mat-select>
        <mat-label>{{selectCountyText}}</mat-label>
      </mat-form-field>

      <!-- STATE -->
      <mat-form-field appearance="outline" class="maxWidth350">
        <input matInput formControlName="state" maxlength="5" disabled readonly />
        <mat-label>State</mat-label>
      </mat-form-field>

    </div>

    <div class="button-container">
      <button mat-raised-button color="primary" type="submit">Go to Marketplace</button>
      <button mat-raised-button color="primary" (click)="cancelCreation()">Cancel</button>
    </div>
  </form>
